<template>
  <div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始周" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="week"
          placeholder="选择周"
          format="WW"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束周" prop="startDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="week"
          placeholder="选择周"
          format="WW"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
      </el-form-item>
    </el-form>

    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </div>
</template>

<script>
import echarts from 'echarts'
import { getWeekCountryData } from '@/api/config/week-stat'

export default {
  name: 'WeekCountry',
  props: {
    typ: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      text: {
        1: '新增用户',
        2: '日均DAU',
        3: '周付费收入'
      },
      loading: false,
      countryMap: {
        'FR': '法国',
        'DE': '德国',
        'GB': '英国',
        'US': '美国',
        'MY': '马来西亚'
      },
      chart: {},
      option: {},
      queryParams: {
        startDate: '',
        endDate: '',
        type: 1
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery() {
      this.getTables()
    },
    getTables() {
      this.loading = true
      this.queryParams.type = this.typ
      getWeekCountryData(this.queryParams).then(res => {
        this.loading = false
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        const data = res.data.data
        const countryArr = {}
        const date = {}
        for (const i in data) {
          const val = data[i]
          date[val.week] = val.week
          if (countryArr[val.country] === undefined) {
            countryArr[val.country] = []
          }
          countryArr[val.country].push(val.num)
        }
        this.option.title.text = this.text[this.typ]
        // console.log('countryArr', countryArr)
        for (const i in date) {
          this.option.xAxis.data.push(`第${i}周`)
        }
        for (const i in countryArr) {
          const val = countryArr[i]
          this.option.legend.data.push(this.countryMap[i])
          const temp = {
            name: this.countryMap[i],
            data: val,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
          this.option.series.push(temp)
        }

        this.chart.setOption(this.option, true)
      })
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: ''
        },
        xAxis: {
          name: '时间',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '今日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: 'red' // 改变线条颜色
              }
            }
          },
          {
            name: '昨日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: '#00BFFF' // 改变线条颜色
              }
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>

</style>
